<template>
    <v-row justify="center">
        <v-col sm="12" class="mb-0 pb-0">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="60vw"
                height="60vh"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        block
                        v-bind="attrs"
                        v-on="on"
                        :class="classes"
                        :disabled="disabled"
                    >
                        Trimitere document
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Trimitere document / notificare</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-combobox
                                        v-model="form.recipients"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('recipients.0')"
                                        :class="{ 'error--text': hasErrors('recipients.0') }"
                                        class="primary--text"
                                        name="recipients"
                                        label="E-mail destinatar"
                                        data-vv-as="E-mail destinatar"
                                        data-vv-name="recipients"
                                        multiple
                                        chips
                                        deletable-chips
                                    />
                                    <v-alert
                                        v-if="hasErrors('recipients')"
                                        dense
                                        type="error"
                                        v-html="errorMessages('recipients').join('<br/>')"
                                    ></v-alert>
                                    <v-text-field
                                        v-model="form.email_subject"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('email_subject')"
                                        :class="{ 'error--text': hasErrors('email_subject') }"
                                        class="primary--text"
                                        name="email_subject"
                                        label="Subiect e-mail"
                                        data-vv-as="Subiect e-mail"
                                        data-vv-name="email_subject"
                                    />
                                    <v-textarea
                                        v-model="form.email_body"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('email_body')"
                                        :class="{ 'error--text': hasErrors('email_body') }"
                                        class="primary--text"
                                        name="email_body"
                                        label="Continut e-mail"
                                        data-vv-as="Continut e-mail"
                                        data-vv-name="email_body"
                                    />
                                    <v-select
                                        :items="attachments"
                                        item-value="id"
                                        item-text="text"
                                        v-model="form.data.attachments"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.attachments')"
                                        :class="{ 'error--text': hasErrors('data.attachments') }"
                                        class="primary--text"
                                        name="data.attachments"
                                        label="Atasamente"
                                        data-vv-as="Atasamente"
                                        data-vv-name="data.attachments"
                                        multiple
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-expansion-panels v-if="notifications.length">
                                        <v-expansion-panel v-for="(notification, nIndex) in notifications" :key="nIndex">
                                            <v-expansion-panel-header>
                                                {{ notification.email_subject }} -
                                                <small>{{ new Date(notification.created_at) | datetime }}</small>
                                                <v-spacer></v-spacer>
                                                {{ _.get(notification, 'created_by.name', 'Nedefinit') }}
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                {{ notification.email_body }}<br/><br/>
                                                <template v-if="_.get(notification, 'data.attachments', []).length">
                                                    <b>Atasamente:</b>
                                                    {{ (new $db.Offer).attachments.filter((attachment) => _.get(notification, 'data.attachments', []).indexOf(attachment.id) >= 0).map(attachment => attachment.text).join(', ') }}
                                                </template>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <v-alert
                                        v-else
                                        dense
                                        type="info"
                                    >
                                        Nu sunt date inregistrate.
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="orange darken-1"
                            text
                            :disabled="form.busy"
                            @click="dialog = false"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="green darken-1"
                            text
                            :loading="form.busy"
                            @click="submit"
                        >
                            Trimitere
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>
<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    export default {
        mixins: [validationError],
        props: {
            customerId: {
                type: [String, Number],
                required: true
            },
            subjectType: {
                type: String,
                required: true
            },
            subjectId: {
                type: [String, Number],
                required: true
            },
            classes: {
                type: [Array, String],
                default() {
                    return ''
                }
            },
            attachments: {
                type: Array,
                default() {
                    return []
                }
            },
            disabled: {
                type: Boolean,
                default () {
                    return true
                }
            }
        },
        data () {
            return {
                dialog: false,
                notifications: [],
                form: new Form({
                    subject_type: this.subjectType,
                    subject_id: this.subjectId,
                    recipients: null,
                    email_subject: null,
                    email_body: null,
                    data: {
                        attachments: []
                    }
                })
            }
        },
        watch: {
            dialog: {
                handler(val) {
                    if(val && this.notifications.length < 1) {
                        this.loadNotifications()
                    }
                    if(!val) {
                        this.resetForm()
                    }
                }
            }
        },
        methods: {
            resetForm() {
                this.form = new Form({
                    subject_type: this.subjectType,
                    subject_id: this.subjectId,
                    recipients: null,
                    email_subject: null,
                    email_body: null,
                    data: {
                        attachments: []
                    }
                })
            },
            async loadNotifications() {
                await (new this.$db.Customer({id: this.customerId}))
                    .notifications()
                    .include('createdBy')
                    .orderBy('-created_at')
                    .get()
                    .then(({data}) => {
                        this.notifications = data
                    })
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                new this.$db.Customer({id: this.customerId}).notifications().attach(self.form)
                    .then(response => {
                        self.$validator.reset();
                        self.showSuccess();
                        self.resetForm()
                        this.loadNotifications()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            }
        }
    }
</script>
